import React from 'react';
import { Col, Row } from '@yme/atoms/grid';
import { Skeleton, GallerySkeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { AspectRatio } from '@yme/utils/constants';
import { CardPanelSkeleton } from '../CardPanel';
import { DescriptionSkeleton } from '../Description';
export function CardSkeleton({ mobileMargin, tabletMargin, desktopMargin }) {
    const { isInfiniteDesktopView } = useWindowSize();
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { mt: mobileMargin, mdMt: tabletMargin, lgMt: desktopMargin, isBrandedCardGrid: true },
            React.createElement(Col, { lg: 7, md: 8 },
                !isInfiniteDesktopView && React.createElement(DescriptionSkeleton, null),
                React.createElement(GallerySkeleton, { aspectRatio: AspectRatio.Square }),
                isInfiniteDesktopView && (React.createElement(Skeleton, { skeletonProps: {
                        height: 52,
                    }, wrapperProps: {
                        mtL: 64,
                    } }))),
            React.createElement(Col, { lg: 5, md: 8 },
                isInfiniteDesktopView && React.createElement(DescriptionSkeleton, null),
                React.createElement(CardPanelSkeleton, null))),
        !isInfiniteDesktopView && (React.createElement(Skeleton, { skeletonProps: {
                height: 52,
            }, wrapperProps: {
                mtS: 48,
                mtM: 64,
                mlS: 16,
                mrS: 16,
                mlM: 45,
                mrM: 45,
            } }))));
}
